import { render, staticRenderFns } from "./AccidentsPage.vue?vue&type=template&id=77bf04de&scoped=true&"
import script from "./AccidentsPage.vue?vue&type=script&lang=js&"
export * from "./AccidentsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bf04de",
  null
  
)

export default component.exports